module.exports = __webpack_public_path__ + "img/ramenoben.22bf32a3.jpg";